import React, { useState, useRef } from 'react';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import emailjs from '@emailjs/browser';

const ReportProblem: React.FC = () => {
  const form = useRef<HTMLFormElement>(null);
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const sendEmail = (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.current) return;

    setIsSending(true);
    setError(null);
    setSuccess(null);

    emailjs.sendForm(
      process.env.REACT_APP_EMAILJS_SERVICE_ID!,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID!,
      form.current,
      process.env.REACT_APP_EMAILJS_USER_ID!
    )
    .then((result) => {
        setSuccess('Your problem report has been sent successfully!');
        form.current?.reset();
    }, (error) => {
        console.error('EmailJS Error:', error);
        setError('Failed to send the report. Please try again later.');
    })
    .finally(() => {
        setIsSending(false);
    });
  };

  return (
    <Container className="mt-5 mb-5">
      <Card className="shadow-sm home-card">
        <Card.Header as="h4" className="card-title-custom text-center">Report a Problem</Card.Header>
        <Card.Body>
          <div className="text-center mb-4">
            <Link to="/" className="btn btn-secondary">Back to Home</Link>
          </div>
          <p>
            Please fill out the form below to report a problem. Provide as much detail as possible.
          </p>
          {error && <Alert variant="danger">{error}</Alert>}
          {success && <Alert variant="success">{success}</Alert>}
          <Form ref={form} onSubmit={sendEmail}>
            <Form.Group className="mb-3" controlId="formUserName">
              <Form.Label>Your Name</Form.Label>
              <Form.Control type="text" name="user_name" placeholder="Enter your name" required />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formUserEmail">
              <Form.Label>Your Email</Form.Label>
              <Form.Control type="email" name="user_email" placeholder="Enter your email" required />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formProblemDescription">
              <Form.Label>Problem Description</Form.Label>
              <Form.Control as="textarea" name="message" rows={5} placeholder="Describe the problem in detail" required />
            </Form.Group>
            <div className="text-center">
              <Button variant="primary" type="submit" disabled={isSending}>
                {isSending ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Send Report'}
              </Button>
            </div>
          </Form>
          <div className="text-center mt-4">
            <Link to="/" className="btn btn-secondary">Back to Home</Link>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ReportProblem;
